
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jt6zg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eff346c96104503c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $eff346c96104503c$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "\u65B0\u589E\u5C08\u5C6C\u7684\u8868\u60C5\u7B26\u865F",
    'fabric.emoji.add.label': "\u65B0\u589E\u8868\u60C5\u7B26\u865F",
    'fabric.emoji.cancel.label': "\u53D6\u6D88",
    'fabric.emoji.categories.label': "\u9078\u64C7\u8868\u60C5\u7B26\u865F\u985E\u5225",
    'fabric.emoji.categories.search.results': "\u641C\u5C0B\u7D50\u679C",
    'fabric.emoji.category.activity': "\u6D3B\u52D5",
    'fabric.emoji.category.all.uploads': "\u6240\u6709\u4E0A\u50B3\u9805\u76EE",
    'fabric.emoji.category.flags': "\u65D7\u6A19",
    'fabric.emoji.category.foods': "\u98DF\u7269\u548C\u98F2\u6599",
    'fabric.emoji.category.frequent': "\u5E38\u7528\u9805\u76EE",
    'fabric.emoji.category.nature': "\u81EA\u7136",
    'fabric.emoji.category.objects': "\u7269\u9AD4",
    'fabric.emoji.category.people': "\u4EBA\u54E1",
    'fabric.emoji.category.places': "\u65C5\u904A\u548C\u5730\u9EDE",
    'fabric.emoji.category.productivity': "\u751F\u7522\u529B",
    'fabric.emoji.category.symbols': "\u7B26\u865F",
    'fabric.emoji.category.user.uploads': "\u60A8\u7684\u4E0A\u50B3\u9805\u76EE",
    'fabric.emoji.choose.file.screenReaderDescription': "\u9078\u64C7\u8868\u60C5\u7B26\u865F\u7684\u6A94\u6848\u3002JPG\u3001PNG \u6216 GIF\u3002\u5927\u5C0F\u4E0A\u9650\u70BA 1 MB",
    'fabric.emoji.choose.file.title': "\u9078\u64C7\u6A94\u6848",
    'fabric.emoji.delete.description': "\u6B64\u8868\u60C5\u7B26\u865F\u7684\u6240\u6709\u73FE\u6709\u57F7\u884C\u500B\u9AD4\u90FD\u5C07\u53D6\u4EE3\u70BA {emojiShortName}",
    'fabric.emoji.delete.label': "\u79FB\u9664",
    'fabric.emoji.delete.screenreader.tooltip': "\u82E5\u8981\u522A\u9664 {shortName} \u8868\u60C5\u7B26\u865F\uFF0C\u8ACB\u6309\u9000\u683C\u9375",
    'fabric.emoji.delete.title': "\u79FB\u9664\u8868\u60C5\u7B26\u865F",
    'fabric.emoji.delete.tooltip': "\u522A\u9664",
    'fabric.emoji.emojipicker.emoi.roledescription': "\u8868\u60C5\u7B26\u865F\u6309\u9215",
    'fabric.emoji.emojipicker.error': "\u932F\u8AA4\uFF01",
    'fabric.emoji.error.delete.failed': "\u79FB\u9664\u5931\u6557",
    'fabric.emoji.error.image.too.big': "\u6240\u9078\u7684\u5F71\u50CF\u8D85\u904E 1 MB",
    'fabric.emoji.error.invalid.image': "\u6240\u9078\u7684\u5F71\u50CF\u7121\u6548",
    'fabric.emoji.error.upload.failed': "\u4E0A\u50B3\u5931\u6557",
    'fabric.emoji.error.upload.timeout': "\u4E0A\u50B3\u903E\u6642",
    'fabric.emoji.image.requirements': "JPG\u3001PNG \u6216 GIF\u3002\u5927\u5C0F\u4E0A\u9650\u70BA 1 MB\u3002",
    'fabric.emoji.name.ariaLabel': "\u8ACB\u8F38\u5165\u65B0\u8868\u60C5\u7B26\u865F\u7684\u540D\u7A31",
    'fabric.emoji.picker': "\u8868\u60C5\u7B26\u865F\u9078\u53D6\u5668",
    'fabric.emoji.pickerlist.grid': "{showSearchResults, select, true {\u641C\u5C0B\u7D50\u679C} other {\u8868\u60C5\u7B26\u865F}}",
    'fabric.emoji.pickerlist.tabpanel': "\u8868\u60C5\u7B26\u865F\u52D5\u4F5C\u548C\u5217\u8868\u9762\u677F",
    'fabric.emoji.placeholder': "\u4F8B\u5982\u60A8\u597D",
    'fabric.emoji.preview': "\u65B0\u7684\u8868\u60C5\u7B26\u865F {emoji} \u770B\u8D77\u4F86\u5F88\u68D2",
    'fabric.emoji.preview.title': "\u9810\u89BD",
    'fabric.emoji.retry.label': "\u91CD\u8A66",
    'fabric.emoji.search.label': "\u8868\u60C5\u7B26\u865F\u540D\u7A31",
    'fabric.emoji.search.placeholder': "\u641C\u5C0B",
    'fabric.emoji.search.status': "\u67E5\u770B\u6240\u6709\u8868\u60C5\u7B26\u865F",
    'fabric.emoji.select.skin.list.ariaLabel': "\u819A\u8272\u9078\u53D6\u5668",
    'fabric.emoji.select.skin.tone.ariaLabel': "\u9078\u53D6\u819A\u8272\uFF0C\u5DF2\u9078\u53D6 {selectedTone}"
};

});


//# sourceMappingURL=zh_TW.a14d33fb.js.map
